import { styled, TextField } from '@mui/material';

const StyledTextField = styled(TextField)({
  background: '#E6E6E6',
  border: '1px solid #808080',
  '.MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  input: {
    color: '#080808',
  },
});

export default StyledTextField;
